export const getFromStore = (state, key, subkey, thirdLevel) => state[key]?.[subkey]?.[thirdLevel];
